// extracted by mini-css-extract-plugin
export default {"home-page":"home-page--lJiJVrQqhAdCqrwd648d","home-page--main":"home-page--main--Xc8cYmBPVqlY6UOdwRel","home-page__header":"home-page__header--H2DRe_Czu8Jhc9gMiwFw"};